/* eslint-disable no-prototype-builtins,no-restricted-syntax */
import _ from 'lodash'
import i18n from '@/libs/i18n'
import SettlementStatusDictionary from '@/dictionary/SettlementStatusDictionary'

const cloneNested = obj => _.cloneDeep(obj)
const randomPassword = () => Array(20)
  .fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz')
  // eslint-disable-next-line no-mixed-operators
  .map(x => x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1) * x.length)])
  .join('')

const checkNested = (obj, level, ...rest) => {
  if (obj === undefined) return false
  if (rest.length === 0 && obj.hasOwnProperty(level)) return true
  return checkNested(obj[level], ...rest)
}

const strToDecimal = str => Number(Number(str).toFixed(2))

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)

const showValidationErrors = children => {
  // Recursively walk validation children and show any error strings
  if (!children) return
  // eslint-disable-next-line guard-for-in
  for (const key in children) {
    const child = children[key]
    if (checkNested(child, 'errors')) {
      child.errors.forEach(e => {
        window.toast.notify.warning(
          i18n.t('validations.messages.Validation Failed'),
          i18n.t(`validations.messages.${e}`),
        )
      })
    } else if (checkNested(child, 'children')) {
      showValidationErrors(child.children)
    }
  }
}

const parseRequestError = err => {
  const { response } = err

  if (!response) {
    // eslint-disable-next-line no-console
    console.log(err)
    return
  }

  if (response.status === 403) {
    return
  }

  const { data } = response
  if (!data) {
    return
  }

  if (checkNested(data, 'errors', 'children')) {
    showValidationErrors(data.errors.children)
  } else if (checkNested(data, 'message')) {
    if (data.message === 'Validation Failed' && checkNested(data, 'errors', 'errors')) {
      data.errors.errors.forEach(error => {
        window.toast.notify.warning(
          i18n.t('validations.messages.Validation Failed'),
          i18n.t(`validations.messages.${error}`),
        )
      })
    } else {
      window.toast.notify.danger(i18n.t(data.message))
    }
    // console.error(response)
  }
}
const empty = data => {
  if (typeof (data) === 'number' || typeof (data) === 'boolean') {
    return false
  }
  if (typeof (data) === 'undefined' || data === null) {
    return true
  }
  if (typeof (data.length) !== 'undefined') {
    return data.length === 0
  }
  let count = 0
  for (const i in data) {
    if (data.hasOwnProperty(i)) {
      count += 1
    }
  }
  return count === 0
}

const sort = data => _.orderBy(
  data,
  [
    item => item.customer.lastName,
    item => item.customer.firstName,
  ],
  'asc',
)

const safePush = (arr, value) => {
  let newArr = arr
  if (typeof arr === 'undefined') {
    newArr = []
  }

  newArr.push(value)

  return newArr
}

const getIntegers = number => Math.floor(number)
const getDecimals = number => Math.round((Math.abs(number) % 1) * 100)
  .toLocaleString('pl-PL', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })

const getColorVariantByPaymentStatus = status => {
  switch (status) {
    case SettlementStatusDictionary.ToPay:
      return 'warning'
    case SettlementStatusDictionary.OverduePayment:
      return 'danger'
    case SettlementStatusDictionary.Paid:
      return 'success'
    case SettlementStatusDictionary.Scheduled:
      return 'secondary'
    default:
      return 'info'
  }
}

const isUrl = str => {
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/
  return urlRegex.test(str)
}

const fixAndReturnUrl = urlString => {
  let url = urlString
  if (!/^https?:\/\//i.test(urlString)) {
    url = `http://${url}`
  }

  // Create and return URL object
  try {
    return new URL(url)
  } catch (e) {
    return null // Return null if the URL is invalid
  }
}

const isAnonymizedCustomer = customer => {
  if (!customer) {
    return false
  }

  return customer.dataProcessingStatus === 'ANONYMIZED' || !!customer.anonymizedAt
}

const copyToClipboard = async text => {
  if (!text) return false
  try {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text)
    } else {
      window.toast.notify.warning('Your browser doesn\'t support copying')
    }
    if (window && window.toast && window.toast.notify && window.toast.notify.success) {
      window.toast.notify.success(i18n.t('shared.toast.copied') || 'Copied')
    }
    return true
  } catch (e) {
    if (window && window.toast && window.toast.notify && window.toast.notify.danger) {
      window.toast.notify.danger(i18n.t('shared.toast.copy-failed') || 'Copy failed')
    }
    return false
  }
}

export {
  cloneNested,
  randomPassword,
  parseRequestError,
  checkNested,
  empty,
  strToDecimal,
  capitalizeFirstLetter,
  sort,
  safePush,
  getIntegers,
  getDecimals,
  getColorVariantByPaymentStatus,
  isUrl,
  fixAndReturnUrl,
  isAnonymizedCustomer,
  copyToClipboard,
}
